<template>
  <v-row>
    <v-col cols="12">
      <div v-if="title" class="text-h6 font-weight-bold py-2">
        {{title}}
      </div>
      <div class="px-5">
        <ul>
          <li type="1" v-for="content in contents" :key=content>
            <div class="text-body-1" v-html=content />
          </li>
        </ul>
      </div>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: 'PageContents',
  props: {
    title: String,
    contents: Array
  },
}
</script>

<style>
</style>